
import XHeader from 'vux/src/components/x-header/index.vue'

import { common } from "@/common/index";
export default {
components: { XHeader },
props: {
leftOptions: {
type: Object,
default: () => {
backText: "";
},
},
title: {
type: String,
required: false,
},
isIcon: {
type: String,
required: false,
},
isRightIcon: {
type: String,
required: false,
},
isShow: {
type: Boolean,
default: () => false,
},
isImgShow: {
type: Boolean,
default: () => false,
},
ImageShow: {
type: Boolean,
default: () => false,
},
leftName: {
type: String,
required: false,
},
},
data() {
return {
showSearch: false,
};
},
methods: {
handShowSearch() {
this.showSearch = true;
this.$emit("handShowSearch", this.showSearch);
},
_clickBack() {
this.$router.back(-1);

window.android.JS_APP_GoBack();
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/components/com-header.vue